import { useCallback } from 'react';
import { categoriesService } from '../services';
import {
  useResourceCollection,
  useResourceById,
  useCreateResource,
  useUpdateResource,
  useDeleteResource,
  ResourceState,
  SingleResourceState,
  MutationState,
} from './useResource';
import { ResourceQueryOptions } from '../services/resources.service';
import { Category } from '../types';

export function useCategories(
  options?: ResourceQueryOptions
): ResourceState<Category> & { meta?: any } {
  const fetchFn = useCallback(
    (opts?: ResourceQueryOptions) =>
      categoriesService.getAll(opts) as unknown as Promise<{ data: Category[]; meta?: any }>,
    []
  );
  return useResourceCollection<Category>(fetchFn, options);
}

export function useCategory(
  id: string | null,
  options?: ResourceQueryOptions
): SingleResourceState<Category> {
  const resourceId = id;
  const fetchFn = useCallback(
    (categoryId: string | number, opts?: ResourceQueryOptions) =>
      categoriesService.getById(categoryId, opts) as unknown as Promise<Category>,
    []
  );
  return useResourceById<Category>(fetchFn, resourceId, options);
}

export function useCreateCategory(
  onSuccess?: (data: Category) => void
): MutationState<Category> {
  const createFn = useCallback(
    (data: any) => categoriesService.create(data) as unknown as Promise<Category>,
    []
  );
  return useCreateResource<Category>(createFn, onSuccess);
}

export function useUpdateCategory(
  onSuccess?: (data: Category) => void
): MutationState<Category> {
  const updateFn = useCallback(
    (id: string | number, data: any) => {
      return categoriesService.update(id, data) as unknown as Promise<Category>;
    },
    []
  );
  return useUpdateResource<Category>(updateFn, onSuccess);
}

/**
 * Delete category using documentId
 * @param data - Full category object containing documentId
 */
export function useDeleteCategory(onSuccess?: () => void): MutationState<void> {
  const deleteFn = useCallback(
    (data: any) => {
      const documentId = data.documentId || data.id?.toString() || data.id;
      return categoriesService.delete(documentId) as unknown as Promise<void>;
    },
    []
  );
  return useDeleteResource(deleteFn, onSuccess);
}
// Auto-generated hook file
